export class Cities {
  constructor(
      public IdCity?: number,
      public Name?: string,
      public IdState?: number
  ) { }
}
